import App from 'antd/es/app/App';
import useApp from 'antd/es/app/useApp';

export const AntApp = App;
export const useAntApp = useApp;
